module.exports = __webpack_public_path__ + "static/media/05 Clarinet Region 20 Scales.746fad40.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/middleSchool/scales/05 Clarinet Region 20 Scales.pdf
// module id = 278
// module chunks = 0